import ContentAsset from "@components/BasicComponents/ContentAsset/ContentAsset"
import ContactFree from "@components/BasicComponents/Forms/ContactFree/ContactFree"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import AnimatedButton from "@components/WebsiteRevamp/AnimatedButton/AnimatedButton"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	FAQModuleType,
	HeroModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import CurveSection from "./CurveSection"
import CurveSection2 from "./CurveSection2"
import styles from "./OneFree.module.scss"
import OverviewFAQSection from "../One/OverviewFAQSection/OverviewFAQSection"
import getValueOrThrow from "@helpers/getValueOrError"

type Props = {
	list?: AdvancedSideAssetModuleType[]
	hero?: HeroModuleType
	faq: FAQModuleType[]
}

const OneFree = ({list, hero, faq}: Props) => {
	return (
		<>
			<ContainerWrapper
				style={{
					position: "relative",
				}}
			>
				<CurveSection2
					childrenOutOfBox={
						<img
							src={hero?.desktopAsset?.src ?? ""}
							className={styles.desctopImageHero}
						/>
					}
					style={{
						background:
							"linear-gradient(-9deg, #9BF 17.82%, #F1F5FF 95.93%)",
						//  `url(${hero?.desktopAsset?.src})`
					}}
				>
					<div
						style={{
							position: "relative",
							zIndex: 2,
						}}
						className={`${styles.curveSectionHero}`}
					>
						<NewResponsiveImage
							{...hero?.mobileAsset}
							containerClassName={styles.mobileImageHeroContainer}
							imageClassName={styles.mobileImageHero}
							src={hero?.mobileAsset?.src ?? ""}
							alt={hero?.title ?? hero?.mobileAsset?.alt ?? ""}
						/>
						{/* <NewResponsiveImage
							{...hero?.beforeTitlesIcon}
							containerClassName={styles.imagecontainerClassName}
							imageClassName={styles.imageClassName}
							src={hero?.beforeTitlesIcon?.src ?? ""}
							alt={
								hero?.title ?? hero?.beforeTitlesIcon?.alt ?? ""
							}
						/> */}
						{/* <Separator size={48} /> */}
						<Typography
							fontWeight={200}
							size={Size.XXL}
							as={"h1"}
							className={styles.heroTitle}
							style={{
								letterSpacing: "-1.5px",
								fontFamily: '"Inter", sans-serif !important',
							}}
							noPadding
							content={hero?.title}
						/>
						{/* <Separator size={48} /> */}
						<ButtonContainer className={styles.buttonContainer}>
							<AnimatedButton
								{...hero?.buttons?.[0]}
								href={hero?.buttons?.[0].link ?? "#"}
								className={styles.buttonLarge}
								contrast={"light"}
								theme={"oneDefault"}
								variant={"primary"}
								text={
									hero?.buttons?.[0].text ??
									"Get Personal #One for FREE"
								}
							/>
						</ButtonContainer>
					</div>
				</CurveSection2>
			</ContainerWrapper>
			<ContainerWrapper
				style={{
					top: "-11px",
					background: "white",
					position: "relative",
				}}
			>
				<Separator size={32} />
				<Typography
					variant={Variant.SectionTitle}
					fontWeight={500}
					size={Size.XXL}
					noPadding
					style={{
						letterSpacing: "-0.5px",
					}}
					content={list?.[0].sectionTitle}
				/>
				<Separator size={32} />
				<Typography
					variant={Variant.Description}
					noPadding
					size={Size.S}
					content={list?.[0].sectionSubtitle}
					fontWeight={300}
					style={{
						maxWidth: "1023px",
						// margin: "0 auto",
					}}
				/>
				<Separator size={128} />
				<Separator size={64} />
				<ContentAsset
					data={list?.[0]?.mainContent?.[0]}
					mainContainerClass={styles.mainContainerClass}
					direction={"left"}
					contentProps={{
						titleProps: {
							style: {
								color: "#175EEB",
								letterSpacing: "-0.5px",
							},
							size: Size.XL,
						},
						contentProps: {
							size: Size.S,
							fontWeight: 300,
						},
					}}
				/>
				<Separator size={256} />
			</ContainerWrapper>
			<ContainerWrapper>
				<CurveSection className={`${styles.curveSection}`}>
					<ContentAsset
						data={list?.[0]?.mainContent?.[1]}
						direction={"right"}
						mainContainerClass={`${styles.mainContainerClassCurve} ${styles.mainContainerClass}`}
						contentProps={{
							titleProps: {
								style: {
									color: "#175EEB",
									letterSpacing: "-0.5px",
								},
								size: Size.XL,
							},
							contentProps: {
								size: Size.S,
								fontWeight: 300,
							},
						}}
					/>
					<NewResponsiveImage
						// {...hero?.mobileAsset}
						containerClassName={styles.sectionBottomIcons}
						// imageClassName={styles.mobileImageHero}
						src={"/icons_free.png"}
						width={698}
						height={156}
						alt={
							list?.[0]?.mainContent?.[1].title ??
							hero?.mobileAsset?.alt ??
							""
						}
					/>
				</CurveSection>
			</ContainerWrapper>

			<ContainerWrapper>
				<Separator size={128} />
				<ContentAsset
					data={list?.[0]?.mainContent?.[2]}
					mainContainerClass={`${styles.mainContainerClass}`}
					direction={"left"}
					contentProps={{
						titleProps: {
							style: {
								color: "#175EEB",
								letterSpacing: "-0.5px",
							},
							size: Size.XL,
						},
						contentProps: {
							size: Size.S,
							fontWeight: 300,
						},
					}}
				/>
			</ContainerWrapper>
			<Separator size={128} />
			<ContainerWrapper>
				<div className={styles.formContainer} id={"sign-up"}>
					<Typography
						variant={Variant.Title}
						size={Size.XL}
						style={{
							letterSpacing: "-0.5px",
						}}
						contrast
						noPadding
						content={list?.[1]?.mainContent?.[0].title}
					/>
					<Separator size={32} />

					{/* contentProps={{
						titleProps: {
							style: {
								color: "#175EEB",
								letterSpacing: "-0.5px",
							},
							size: Size.XL,
						},
						contentProps: {
							size: Size.S,
							fontWeight: 300,
						},
					}} */}
					<Typography
						fontWeight={300}
						style={{
							maxWidth: "clamp(620px, 75%, 1100px)",
						}}
						size={Size.S}
						noPadding
						contrast
						content={list?.[1]?.mainContent?.[0].content}
					/>
					<Separator />
					<div className={styles.formFlex}>
						<div className={styles.formBox}>
							<ContactFree
								container={{
									style: {
										color: "black",
									},
								}}
							/>
						</div>
						<div className={styles.buttonsContainer}>
							{list?.[1]?.mainContent?.[0]?.buttons?.[0] && (
								<ButtonComponent
									className={styles.button}
									asLink={
										list?.[1]?.mainContent?.[0]
											?.buttons?.[0].linkPopup
									}
									{...list?.[1]?.mainContent?.[0]
										?.buttons?.[0]}
									buttonType={"primary"}
									// brand="one"
									// contrast
								>
									{
										list?.[1]?.mainContent?.[0]
											?.buttons?.[0].text
									}
								</ButtonComponent>
							)}

							{list?.[1]?.mainContent?.[0]?.buttons?.[1] && (
								<ButtonComponent
									className={styles.buttonImage}
									asLink={
										list?.[1]?.mainContent?.[0]
											?.buttons?.[1].linkPopup
									}
									{...list?.[1]?.mainContent?.[0]
										?.buttons?.[1]}
									buttonType={"unstyled"}
								>
									{
										list?.[1]?.mainContent?.[0]
											?.buttons?.[1].text
									}
								</ButtonComponent>
							)}
							{list?.[1]?.mainContent?.[0]?.buttons?.[2] && (
								<ButtonComponent
									className={styles.buttonImage}
									asLink={
										list?.[1]?.mainContent?.[0]
											?.buttons?.[2].linkPopup
									}
									{...list?.[1]?.mainContent?.[0]
										?.buttons?.[2]}
									buttonType={"unstyled"}
								>
									{
										list?.[1]?.mainContent?.[0]
											?.buttons?.[2].text
									}
								</ButtonComponent>
							)}
						</div>
					</div>
				</div>
			</ContainerWrapper>
			<OverviewFAQSection faq={faq} />
		</>
	)
}

export default OneFree
